import { render } from "./ErrorModal.vue?vue&type=template&id=56970b46"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"

import "./ErrorModal.vue?vue&type=style&index=0&id=56970b46&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__